import type { FaireProductEntity } from "../../entity_types/product";

export const p_jz6bubavx3: FaireProductEntity = {
  token: "p_jz6bubavx3",
  type: "product",
  name: "Cool Moms Love Jesus Tee, Retro Faith Graphic T-Shirt",
  brandToken: "b_hg3vtct9kg",
  brandName: "Eleven Fashion",
  imageUrl:
    "https://cdn.faire.com/fastly/29ce31f621fa2e587c0065838277fe6f161227b823c9eed82bdc684177f9c4e9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/31919000756128c812f848d6c84ffd184ad42d99f8ec1e6e9c88c0f3f6712c52.jpeg",
  ],
  priceDollars: 11.99,
  description:
    "A best-selling favorite for boutiques, gift shops, and faith-based stores. This “Cool Moms Love Jesus” tee features a bold retro font with a clean, minimalist design that pairs perfectly with jeans, cardigans, and everyday casual looks.\nMade with soft, high-quality cotton for comfort your customers will want to wear all day.\n\n• Soft unisex tee\n• Retro block lettering\n• Faith-inspired everyday wear\n• Perfect for moms, church gifts, and Christian boutiques\n• DTG printed for lasting color\n• Sizes: S–3XL\n• Fabric: 100% ringspun cotton (fiber content may vary by color)\n\nPerfect for Mother’s Day, church events, holiday gifting, and year-round apparel collections.",
  tags: [],
  msrpDollars: 23.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:56.572Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
